import { PropsWithChildren, SVGProps } from 'react'

import { Link } from 'components'

import { combineClassnames } from '../combineClassnames'
import styles from './FormRow.module.scss'

export interface FormRowProps extends PropsWithChildren {
  className?: string
  contentColumnClassName?: string
  description?: string
  error?: string
  icon?: React.FC<SVGProps<SVGSVGElement>>
  inputFieldClassName?: string
  link?: string
  loading?: boolean
  mandatory?: boolean
  mode?: 'column' | 'row'
  title: string
}

const FormRow = ({
  children,
  className,
  contentColumnClassName,
  description,
  error,
  icon: Icon,
  inputFieldClassName,
  link,
  mandatory,
  mode = 'row',
  title,
}: FormRowProps) => {
  const name = `${title}${mandatory ? ' *' : ''}`

  return (
    <div className={combineClassnames(styles.contentRow, className)} {...{ mode }}>
      <div className={combineClassnames(styles.contentColumn, contentColumnClassName)}>
        {Icon && <Icon />}
        <div>
          <div className={styles.name}>{link ? <Link title={name} to={link} /> : name}</div>
          {description && <div className={styles.description}>{description}</div>}
        </div>
      </div>
      <div className={combineClassnames(styles.inputField, inputFieldClassName)}>{children}</div>
      {error && <div className={styles.error}>{error}</div>}
    </div>
  )
}

export default FormRow
